// extracted by mini-css-extract-plugin
module.exports = {"root":"BrandHeader_root__aDDPm","logo":"BrandHeader_logo__qVllY"};